/* eslint-disable sorare/no-detached-fragments */
import { TypedDocumentNode, gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import { TokenLoyaltyBoost } from 'components/token/Token/TokenLoyaltyBoost';

import type {
  SealingCardsMutation,
  SealingCardsMutationVariables,
} from './__generated__/useSealingMutation.graphql';

const mutation = gql`
  mutation SealingCardsMutation($input: sealCardsInput!) {
    sealCards(input: $input) {
      cards {
        slug
        sealedFor
        ...TokenLoyaltyBoost_anyCard
      }
      errors {
        message
      }
    }
  }
  ${TokenLoyaltyBoost.fragments.anyCard}
` as TypedDocumentNode<SealingCardsMutation, SealingCardsMutationVariables>;

export const useSealingMutation = () => {
  return useMutation(mutation, {
    showErrorsWithSnackNotification: true,
  });
};
